import { useNavigate } from 'react-router-dom'
import { Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName, IconPrefix, faArrowRight } from '@fortawesome/free-solid-svg-icons'

import { FC } from 'react'
import type { FeatureKey } from '../../../config/features'

export interface AdminBtn {
    id: number
    link: string
    label: string
    icon: IconName
    iconPrefix?: IconPrefix
    badge?: any
    featureKey?: FeatureKey
    description?: string
    color?: string
    gradient?: string
}

const AdminButton: FC<AdminBtn> = ({
    label,
    link,
    icon,
    iconPrefix = 'fas',
    badge,
    description,
    color = '#0a63ea',
    gradient = 'linear-gradient(135deg, #0a63ea, #083bb0)',
}) => {
    const navigate = useNavigate()

    return (
        <Col xl={4} xxl={3} lg={6} className="mb-4">
            <button
                className="admin-card"
                onClick={() => navigate(link)}
                style={
                    {
                        '--admin-card-color': color,
                        '--admin-card-gradient': gradient,
                    } as React.CSSProperties
                }
            >
                <div className="admin-card__icon-wrapper">
                    <div
                        className="admin-card__icon"
                        style={{ background: gradient }}
                    >
                        <FontAwesomeIcon icon={[iconPrefix, icon]} />
                    </div>
                </div>
                <div className="admin-card__body">
                    <h3 className="admin-card__title">{label}</h3>
                    {description && (
                        <p className="admin-card__desc">{description}</p>
                    )}
                </div>
                <div className="admin-card__footer">
                    <span className="admin-card__arrow">
                        <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                </div>
                {badge && <div className="admin-card__badge">{badge}</div>}
                <div className="admin-card__shine" />
            </button>
        </Col>
    )
}

export default AdminButton
